$(".slider_logo_list").slick({
  dots: false,
  infinite: true,
  speed: 700,
  slidesToShow: 6,
  slidesToScroll: 6,
  autoplay: true,
  autoplaySpeed: 2000,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 549,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
  ],
});

if (window.innerWidth < 1024) {
  $(".collage_wrapper").slick({
    dots: false,
    arrow: false,
    infinite: true,
    speed: 400,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 3,
          infinite: true,
        },
      },
      {
        breakpoint: 549,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
}
document.addEventListener("DOMContentLoaded", function () {
  const disclosures = document.querySelectorAll("details-disclosure");
  disclosures.forEach(function (disclosure) {
    const content = disclosure.querySelector(".disclosure__content");
    if (!content || content.innerHTML.trim() === "") {
      disclosure.style.display = "none";
    }
  });
});
